import { StateType } from '../index';
import { BaseCustomPreferencesStore } from './CustomPreferencesReducer';

const SLICE_KEY = 'customPreferences';

export const customPreferencesSelector = (state: StateType): BaseCustomPreferencesStore => {
  // Production root state is an Immutable.Map (via redux-immutable); tests may use a plain object.
  const fromImmutable = typeof (state as any)?.get === 'function' ? (state as any).get(SLICE_KEY) : undefined;
  return (fromImmutable ?? (state as any)?.[SLICE_KEY]) as BaseCustomPreferencesStore;
};

export const getIsSimulationWalkthroughComplete = (state: StateType) => {
  return customPreferencesSelector(state)?.preferences?.simulationWalkthrough;
};

export const getIsGoldDialogShown = (state: StateType) => {
  return customPreferencesSelector(state)?.preferences?.goldDialogShown;
};

// 'YYYY-QN' quarter the streak-freeze unlock modal was last shown in. Cross-device
// gate (at most once per quarter)
export const getStreakFreezeUnlockShownQuarter = (state: StateType) => {
  return customPreferencesSelector(state)?.preferences?.streakFreezeUnlockShownQuarter;
};

// `freeze.usedDate` the protected modal was last shown for, so it shows at most once per applied freeze.
export const getStreakProtectedShownDate = (state: StateType) => {
  return customPreferencesSelector(state)?.preferences?.streakProtectedShownDate;
};

export const getIsCustomPreferencesFetching = (state: StateType) => {
  return customPreferencesSelector(state)?.fetching ?? false;
};
